import i18n from "i18next";
import { ReactNode } from "react";
import { I18nextProvider, initReactI18next } from "react-i18next";

import ar from "@/locales/ar.json";
import de from "@/locales/de.json";
import en from "@/locales/en.json";
import es from "@/locales/es.json";
import it from "@/locales/it.json";
import tr from "@/locales/tr.json";

import { SETTINGS_KEYS, getLocalSetting } from "./settings-provider";

i18n.use(initReactI18next).init({
    lng: getLocalSetting(SETTINGS_KEYS.LANGUAGE) as string,
    fallbackLng: "en",

    resources: {
        es: { translation: es },
        en: { translation: en },
        de: { translation: de },
        tr: { translation: tr },
        ar: { translation: ar },
        it: { translation: it },
    },
});

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
